import { notesFiscalUpdateTypes } from "./notesFiscalUpdateTypes";
import { newDate } from "../../../helpers/dateTools";

const {
  SET_NOTES_FISCAL_UPDATE_FILTERS,
  GET_NOTES_FISCAL_UPDATE,
  SELECT_NOTE_TO_FISCAL_UPDATE,
  DESELECT_NOTE_TO_FISCAL_UPDATE,
  DO_NOTES_FISCAL_UPDATE,
  SELECT_NEXT_NOTES_FISCAL_UPDATE,
  CLEAR_NOTES_FISCAL_UPDATE,
  SET_CONFIG_FILTER_NOTES_FISCAL_UPDATE,
  SET_CONFIG_PAGE_NOTES_FISCAL_UPDATE,
  SET_CONFIG_PAGE_SIZE_NOTES_FISCAL_UPDATE,
  SET_CONFIG_SORTED_NOTES_FISCAL_UPDATE,
} = notesFiscalUpdateTypes;

const INITIAL_STATE = {
  notesFiscalUpdateArr: [],
  notesToFiscalUpdate: new Map(),
  station: {},
  startDate: newDate(),
  endDate: newDate(),
  config: {
    page: 0,
    pageSize: 20,
    filtered: [],
    sorted: [],
  },
};

export const notesFiscalUpdateReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SET_NOTES_FISCAL_UPDATE_FILTERS:
      return {
        ...state,
        [payload.key]: payload.data,
      };

    case GET_NOTES_FISCAL_UPDATE: {
      const limit = parseInt(process.env.REACT_APP_LIMIT_FETCH_NOTES) || 50;
      const firstItemsSelected = payload.slice(0, limit);
      return {
        ...state,
        notesFiscalUpdateArr: payload,
        notesToFiscalUpdate: new Map(firstItemsSelected.map((note) => [note?.id, true])),
      };
    }

    case SELECT_NEXT_NOTES_FISCAL_UPDATE: {
      const currentSelectionSize = state.notesToFiscalUpdate.size;
      const selectionLimit = parseInt(process.env.REACT_APP_LIMIT_FETCH_NOTES, 10) || 50;
      const allNotes = [...state.notesFiscalUpdateArr];

      if (currentSelectionSize >= allNotes.length || currentSelectionSize >= selectionLimit) {
        return state;
      }

      const remainingSlots = selectionLimit - currentSelectionSize;
      const nextNotesToSelect = allNotes.slice(currentSelectionSize, currentSelectionSize + remainingSlots);
      const newNotesToFiscalUpdate = new Map(state.notesToFiscalUpdate);
      nextNotesToSelect.forEach((note) => newNotesToFiscalUpdate.set(note.id, true));

      return {
        ...state,
        notesToFiscalUpdate: newNotesToFiscalUpdate,
      };
    }

    case SELECT_NOTE_TO_FISCAL_UPDATE: {
      const selectionLimit = parseInt(process.env.REACT_APP_LIMIT_FETCH_NOTES, 10) || 50;
      if (state.notesToFiscalUpdate.size >= selectionLimit) {
        return state;
      }
      const newNotesToFiscalUpdate = new Map(state.notesToFiscalUpdate);
      newNotesToFiscalUpdate.set(payload, true);
      return {
        ...state,
        notesToFiscalUpdate: newNotesToFiscalUpdate,
      };
    }

    case DESELECT_NOTE_TO_FISCAL_UPDATE: {
      const editedNotesToFiscalUpdate = new Map(state.notesToFiscalUpdate);
      editedNotesToFiscalUpdate.delete(payload);
      return {
        ...state,
        notesToFiscalUpdate: editedNotesToFiscalUpdate,
      };
    }

    case DO_NOTES_FISCAL_UPDATE:
      return {
        ...state,
        notesFiscalUpdateArr: state.notesFiscalUpdateArr.filter((note) => !state.notesToFiscalUpdate.has(note.id)),
        notesToFiscalUpdate: new Map(),
      };

    case CLEAR_NOTES_FISCAL_UPDATE:
      return {
        ...state,
        ...INITIAL_STATE,
      };

    case SET_CONFIG_FILTER_NOTES_FISCAL_UPDATE:
      return {
        ...state,
        config: {
          ...state.config,
          filtered: payload,
          page: 0,
        },
      };

    case SET_CONFIG_PAGE_NOTES_FISCAL_UPDATE:
      return {
        ...state,
        config: {
          ...state.config,
          page: payload,
        },
      };

    case SET_CONFIG_PAGE_SIZE_NOTES_FISCAL_UPDATE:
      return {
        ...state,
        config: {
          ...state.config,
          pageSize: payload,
          page: 0,
        },
      };

    case SET_CONFIG_SORTED_NOTES_FISCAL_UPDATE:
      return {
        ...state,
        config: {
          ...state.config,
          sorted: payload,
          page: 0,
        },
      };

    default:
      return state;
  }
};
